var _Path, _Path2, _Path3, _Path4, _Path5, _G, _Path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Mask, G, Rect, Ellipse } from "react-native-svg";
function SvgCommunicationPermissions(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 350,
    height: 350,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M236 148H114v78a6 6 0 006 6h110a6 6 0 006-6v-78z",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M232 199.5V224a4 4 0 01-4 4h-8.125M194 228h20M150.5 228h40M118 209.5v-24M118 182.5V174",
    stroke: "#2F2F2F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M178.103 208.671L236 147.797l-56.07-55.766a7 7 0 00-9.86 0L114 147.797l57.897 60.874a4.287 4.287 0 006.206 0z",
    fill: "#FFCED3"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M236 147.797l.181.173a.25.25 0 00-.005-.35l-.176.177zm-57.897 60.874l.182.172-.182-.172zm-6.206 0l-.182.172.182-.172zM114 147.797l-.176-.177a.25.25 0 00-.005.35l.181-.173zm65.93-55.766l-.177.177.177-.177zm-9.86 0l.177.177-.177-.177zm65.749 55.594l-57.897 60.874.363.344 57.896-60.873-.362-.345zm-57.897 60.874a4.038 4.038 0 01-5.844 0l-.363.344a4.538 4.538 0 006.57 0l-.363-.344zm-5.844 0l-57.897-60.874-.362.345 57.896 60.873.363-.344zm64.098-60.879l-56.07-55.766-.353.354 56.071 55.767.352-.355zm-56.07-55.766a7.249 7.249 0 00-10.212 0l.353.354a6.748 6.748 0 019.506 0l.353-.354zm-10.212 0l-56.07 55.766.352.355 56.071-55.767-.353-.354z",
    fill: "#2F2F2F"
  })), /*#__PURE__*/React.createElement(Mask, {
    id: "communication-permissions_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 71,
    width: 122,
    height: 139
  }, _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218 71H114v71h5.326L114 147.297l57.897 60.874a4.287 4.287 0 006.206 0L236 147.297 230.674 142H234V87c0-8.837-7.163-16-16-16z",
    fill: "#FDFAA0"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#communication-permissions_svg__a)"
  }, /*#__PURE__*/React.createElement(Rect, {
    x: 130.281,
    y: 106.285,
    width: 87.225,
    height: 87.225,
    rx: 10.572,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.281 116.857c0-9.152 7.42-16.572 16.572-16.572h66.081c9.153 0 16.572 7.42 16.572 16.572v66.081c0 9.153-7.419 16.572-16.572 16.572h-66.081c-9.152 0-16.572-7.419-16.572-16.572v-66.081zm16.572-4.572a4.572 4.572 0 00-4.572 4.572v66.081a4.572 4.572 0 004.572 4.572h66.081a4.572 4.572 0 004.572-4.572v-66.081a4.572 4.572 0 00-4.572-4.572h-66.081z",
    fill: "#BCF6D7"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M140.853 100.035c-9.29 0-16.822 7.532-16.822 16.822h.5c0-9.014 7.308-16.322 16.322-16.322v-.5zm66.081 0h-66.081v.5h66.081v-.5zm16.822 16.822c0-9.29-7.531-16.822-16.822-16.822v.5c9.015 0 16.322 7.308 16.322 16.322h.5zm0 66.081v-66.081h-.5v66.081h.5zm-16.822 16.822c9.291 0 16.822-7.531 16.822-16.822h-.5c0 9.015-7.307 16.322-16.322 16.322v.5zm-66.081 0h66.081v-.5h-66.081v.5zm-16.822-16.822c0 9.291 7.532 16.822 16.822 16.822v-.5c-9.014 0-16.322-7.307-16.322-16.322h-.5zm0-66.081v66.081h.5v-66.081h-.5zm12.5 0a4.322 4.322 0 014.322-4.322v-.5a4.822 4.822 0 00-4.822 4.822h.5zm0 66.081v-66.081h-.5v66.081h.5zm4.322 4.322a4.322 4.322 0 01-4.322-4.322h-.5a4.822 4.822 0 004.822 4.822v-.5zm66.081 0h-66.081v.5h66.081v-.5zm4.322-4.322a4.322 4.322 0 01-4.322 4.322v.5a4.822 4.822 0 004.822-4.822h-.5zm0-66.081v66.081h.5v-66.081h-.5zm-4.322-4.322a4.322 4.322 0 014.322 4.322h.5a4.822 4.822 0 00-4.822-4.822v.5zm-66.081 0h66.081v-.5h-66.081v.5z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.133 124.564l-21.09 31.637-10.449-16.903-13.61 8.413 14.885 24.078c4.053 6.557 13.533 6.72 17.808.305l25.769-38.656a8 8 0 00-13.313-8.874z",
    fill: "#BBDEFF"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M169.043 156.201l-.213.131.205.332.216-.324-.208-.139zm21.09-31.637l.208.138-.208-.138zm-31.539 14.734l.213-.131-.132-.213-.213.132.132.212zm-13.61 8.413l-.131-.212-.213.131.132.213.212-.132zm14.885 24.078l.212-.132-.212.132zm17.808.305l.208.139-.208-.139zm25.769-38.656l.208.139-.208-.139zm-2.22-11.094l.139-.208-.139.208zm-31.975 33.996l21.09-31.638-.416-.277-21.09 31.637.416.278zm-10.87-16.91l10.449 16.902.426-.262-10.449-16.903-.426.263zm-13.265 8.494l13.609-8.413-.263-.425-13.609 8.413.263.425zm14.965 23.733l-14.884-24.077-.425.263 14.884 24.077.425-.263zm17.388.298c-4.174 6.263-13.43 6.105-17.388-.298l-.425.263c4.149 6.712 13.853 6.879 18.229.313l-.416-.278zm25.769-38.655l-25.769 38.655.416.278 25.769-38.656-.416-.277zm-2.15-10.748a7.751 7.751 0 012.15 10.748l.416.277a8.251 8.251 0 00-2.289-11.441l-.277.416zm-10.747 2.15a7.75 7.75 0 0110.747-2.15l.277-.416a8.25 8.25 0 00-11.44 2.289l.416.277z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M167.512 173.5v0a4.628 4.628 0 01-3.881-2.106L158.5 163.5M176 170l13.5-20m13.5-20l-6.75 10-3.375 5",
    stroke: "#2F2F2F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement(Ellipse, {
    cx: 151.822,
    cy: 143.575,
    rx: 5.515,
    ry: 7.996,
    transform: "rotate(58.05 151.822 143.575)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  }))), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    d: "M127 118v-1c0-7.732 6.268-14 14-14h.5M215 117v0a8 8 0 00-8-8h-4M127 121v26",
    stroke: "#2F2F2F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
export default SvgCommunicationPermissions;